import { DepositType } from "@usher/pe-client-front-end-lib"

export const STEPS = (depositType?: DepositType) => [
  {
    name_id: depositType === DepositType.IBAN ? "tu-step1-iban" : "tu-step1",
    name: "",
    path: "by-crypto",
  },
  {
    name_id: "tu-step2",
    name: "",
    path: "confirmation",
  },
  {
    name_id: "tu-step3",
    name: "",
    path: "instruction",
  },
  {
    name_id: "tu-step4",
    name: "",
    path: "status",
  },
]
